namespace RioERP.Reports {
    export interface OrderTransactionReportForm {
        Id: Serenity.IntegerEditor;
        CustomerId: Serenity.IntegerEditor;
        OrderNumber: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        CustomerEmail2: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        CustomerMobile2: Serenity.StringEditor;
        BillingAddress1: Serenity.StringEditor;
        BillingAddress2: Serenity.StringEditor;
        BillingCity: Serenity.StringEditor;
        BillingStateId: Serenity.IntegerEditor;
        BillingPincode: Serenity.IntegerEditor;
        ShippingToName: Serenity.StringEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingStateId: Serenity.IntegerEditor;
        ShippingPincode: Serenity.IntegerEditor;
        EOrderStatus: Serenity.IntegerEditor;
        EShippingType: Serenity.IntegerEditor;
        DiscountPer: Serenity.DecimalEditor;
        OrderDate: Serenity.DateEditor;
        ESourceType: Serenity.EnumEditor;
        SourceName: Serenity.StringEditor;
        EmailSendCount: Serenity.IntegerEditor;
        IsEmailSent: Serenity.BooleanEditor;
        EPaymentStatus: Serenity.IntegerEditor;
        LastEmailSentDate: Serenity.DateEditor;
        FranchiseeId: Serenity.LookupEditor;
        EOrderProcessBy: Serenity.IntegerEditor;
        DiscountCoupon: Serenity.StringEditor;
        DiscountAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        EShippingStatus: Serenity.IntegerEditor;
        EInvoiceStatus: Serenity.IntegerEditor;
        MailId: Serenity.StringEditor;
        EPaymentType: Serenity.IntegerEditor;
        Gstin: Serenity.StringEditor;
        ExpectedShippingDate: Serenity.DateEditor;
        EInvoiceTo: Serenity.IntegerEditor;
        EFranchiseeDiscountType: Serenity.IntegerEditor;
        EFranchiseeDiscount: Serenity.IntegerEditor;
        FranchiseeDiscountValue: Serenity.DecimalEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        InvoiceCompanyId: Serenity.IntegerEditor;
        ShippingNote: Serenity.StringEditor;
        SourceOrderNumber: Serenity.StringEditor;
        VendorId: Serenity.IntegerEditor;
        TaxAmount: Serenity.DecimalEditor;
        FreezeData: Serenity.BooleanEditor;
        ShippingProviderId: Serenity.IntegerEditor;
        CurrencyId: Serenity.IntegerEditor;
        CurrencyAmount: Serenity.DecimalEditor;
        NetAmountAfterFrDiscount: Serenity.DecimalEditor;
        BillingCountry: Serenity.StringEditor;
        ShippingCountry: Serenity.StringEditor;
        Mode: Serenity.IntegerEditor;
        TransactionId: Serenity.StringEditor;
        PaymentMode: Serenity.EnumEditor;
    }

    export class OrderTransactionReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderTransactionReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderTransactionReportForm.init)  {
                OrderTransactionReportForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;
                var w4 = s.EnumEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.LookupEditor;

                Q.initFormType(OrderTransactionReportForm, [
                    'Id', w0,
                    'CustomerId', w0,
                    'OrderNumber', w1,
                    'CustomerName', w1,
                    'CustomerEmail1', w1,
                    'CustomerEmail2', w1,
                    'CustomerMobile1', w1,
                    'CustomerMobile2', w1,
                    'BillingAddress1', w1,
                    'BillingAddress2', w1,
                    'BillingCity', w1,
                    'BillingStateId', w0,
                    'BillingPincode', w0,
                    'ShippingToName', w1,
                    'ShippingAddress1', w1,
                    'ShippingAddress2', w1,
                    'ShippingCity', w1,
                    'ShippingStateId', w0,
                    'ShippingPincode', w0,
                    'EOrderStatus', w0,
                    'EShippingType', w0,
                    'DiscountPer', w2,
                    'OrderDate', w3,
                    'ESourceType', w4,
                    'SourceName', w1,
                    'EmailSendCount', w0,
                    'IsEmailSent', w5,
                    'EPaymentStatus', w0,
                    'LastEmailSentDate', w3,
                    'FranchiseeId', w6,
                    'EOrderProcessBy', w0,
                    'DiscountCoupon', w1,
                    'DiscountAmount', w2,
                    'GrossAmount', w2,
                    'NetAmount', w2,
                    'TaxableAmount', w2,
                    'EShippingStatus', w0,
                    'EInvoiceStatus', w0,
                    'MailId', w1,
                    'EPaymentType', w0,
                    'Gstin', w1,
                    'ExpectedShippingDate', w3,
                    'EInvoiceTo', w0,
                    'EFranchiseeDiscountType', w0,
                    'EFranchiseeDiscount', w0,
                    'FranchiseeDiscountValue', w2,
                    'FranchiseeDiscountAmount', w2,
                    'InvoiceCompanyId', w0,
                    'ShippingNote', w1,
                    'SourceOrderNumber', w1,
                    'VendorId', w0,
                    'TaxAmount', w2,
                    'FreezeData', w5,
                    'ShippingProviderId', w0,
                    'CurrencyId', w0,
                    'CurrencyAmount', w2,
                    'NetAmountAfterFrDiscount', w2,
                    'BillingCountry', w1,
                    'ShippingCountry', w1,
                    'Mode', w0,
                    'TransactionId', w1,
                    'PaymentMode', w4
                ]);
            }
        }
    }
}
